import { render, staticRenderFns } from "./ConsignmentSummaryReportQtyTable.vue?vue&type=template&id=173854a8&scoped=true"
import script from "./ConsignmentSummaryReportQtyTable.vue?vue&type=script&lang=js"
export * from "./ConsignmentSummaryReportQtyTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173854a8",
  null
  
)

export default component.exports